<template>
  <b-card-body>
    <b-form-row>
      <b-col>
        <b-form-group label="Voor wanneer">
          <b-input-group>
            <b-datepicker
              :value="activiteit.deadline"
              :state="activiteit.deadline != null"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              label-no-date-selected="Voor..."
              @input="updateActiviteit('deadline', $event)"
            />
            <b-input-group-append>
              <b-dropdown text="Q">
                <b-dropdown-item
                  v-for="(i) in deadlineOpties"
                  :key="i.date"
                  @click="updateActiviteit('deadline', i.date)"
                >
                  in {{ i.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Toegewezen aan">
          <inspecteur-select
            :value="activiteit.toegewezen_aan"
            :required="true"
            @input="updateActiviteit('toegewezen_aan', $event)"
          />
          {{ activiteit.toegewezen_aan }}
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Controle door">
          <inspecteur-select
            :value="activiteit.gecontroleerd_door"
            :required="true"
            :allow-beheerders="true"
            :eigen-groep-alleen="true"
            @input="updateActiviteit('gecontroleerd_door', $event ? { Id: $event.id, Naam: $event.naam } : null)"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label="Notitie">
      <b-textarea
        :value="activiteit.omschrijving"
        @input="updateActiviteit('omschrijving', $event)"
      />
    </b-form-group>
  </b-card-body>
</template>
<script>
import { trajectenMixin } from "@/mixins/trajectenMixin";
import InspecteurSelect from '@/components/InspecteurSelect.vue';
// import moment from 'moment';
export default {
  name: 'InspectieStap',
  components: { InspecteurSelect },
  mixins: [trajectenMixin],
  props: {
    totaal: {
      type: Number,
      default: 100
    },
    activiteit: {
      type: Object,
      default: () => {
        return {
          omschrijving: null,
          bedrag: null,
          moment: null,
          gecontroleerd_Door: null,
          toegewezen_aan: null,
          deadline: null
        }
      }
    }
  },
  computed: {
    deadlineOpties() {
      var last_days = [31, 30, 30, 31];
      var j = new Date().getFullYear();
      return [...[1, 2, 3, 4].map((q) => {
        return {
          label: 'Q' + q + ' ' + j,
          date: j + '-' + (q * 3) + '-' + last_days[q - 1]
        }
      })].concat(...[1, 2, 3, 4].map((q) => {
        return {
          label: 'Q' + q + ' ' + (j + 1),
          date: (j + 1) + '-' + (q * 3) + '-' + last_days[q - 1]
        }
      }));
    }
  },
  methods: {
    updateActiviteit(field, value) {
      this.$emit('update:activiteit', {
        ...this.activiteit,
        [field]: value
      });
    }
  }
}
</script>